{
  "WALLBOARD": {
    "LOADING": "Indlæser telefonkøer...",
    "NO_QUEUES": "Ingen telefonkøer fundet.",
    "NO_AGENTS": "Ingen agenter online i denne kø.",
    "UNKNOWN_CALLER": "Ukendt opkalder",
    "STATUS": "Status",
    "TIME": "Tid",
    "AGENT": "Agent",
    "EXTENSION": "Lokalnummer",
    "READY": "Klare agenter",
    "ON_CALL": "Agenter i opkald",
    "PAUSED": "Agenter på pause",
    "WAITING": "Ventende opkald",
    "MISSED_CALLS": "Ubesvarede opkald",
    "HANDLED_CALLS": "Håndterede indgående opkald",
    "OUTBOUND_CALLS": "Håndterede udgående opkald",
    "AVAILABILITY": "Tilgængelighed",
    "AVAILABILITY_TOOLTIP": "Andel af indgående opkald besvaret af agenter (opkald der blev taget)",
    "AGENTS_COUNT": "({onCall} i opkald / {total} i alt)",
    "NO_AVAILABLE": "(ingen online)",
    "WAITING_CALLERS_COUNT": "{count} venter",
    "CALLER": "Opkalder",
    "NUMBER": "Nummer",
    "WAIT_TIME": "Ventetid",
    "ACTION": "Handling",
    "PICKUP_CALL": "Besvar",
    "PICKUP_SUCCESS": "Anmodning om at besvare opkaldet blev sendt.",
    "PICKUP_ERROR": "Kunne ikke besvare opkaldet. Prøv venligst igen.",
    "PICKUP_DISABLED_TOOLTIP": "Du kan ikke besvare et opkald, mens du selv er i et opkald eller offline.",
    "CHAT_STATUS": {
      "NO_ACCESS": "Ingen adgang"
    },
    "PHONE_STATUS": {
      "NO_ACCESS": "Ingen adgang"
    }
  }
}
